/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Describeyoureventindetail4Inputs */

const en_describeyoureventindetail4 = /** @type {(inputs: Describeyoureventindetail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your event in detail...`)
};

const de_describeyoureventindetail4 = /** @type {(inputs: Describeyoureventindetail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreib dein Event…`)
};

/**
* | output |
* | --- |
* | "Describe your event in detail..." |
*
* @param {Describeyoureventindetail4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const describeyoureventindetail4 = /** @type {((inputs?: Describeyoureventindetail4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Describeyoureventindetail4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_describeyoureventindetail4(inputs)
	return de_describeyoureventindetail4(inputs)
});
export { describeyoureventindetail4 as "describeYourEventInDetail" }